<template>
  <div class="inputfiles">
    <div class="inputfiles__file" v-for="(n,i) in nbFiles" :key="n">
      <InputFile v-if="b2Files === null" :id="n" v-on:file-ready="updateFilesObject" :scanii-token="scaniiToken"/>
      <InputFile v-else :id="n" :b2-file-data="b2Files[i]" v-on:file-ready="updateFilesObject" :scanii-token="scaniiToken"/>
      <div>
        <button v-if="b2Files === null || b2Files[i] === undefined" type="button" @click="deleteFile(n)">
          <Minus title="Supprimer ce fichier"/>
        </button>
        <button v-else type="button" @click="deleteServerFile(n,i)">
          <Trash title="Supprimer ce fichier"/>
        </button>
      </div>
    </div>
    <div class="inputfiles__addfile">
      <button type="button" @click="addFile">
        <Plus title="Ajouter un fichier"/>
      </button>
    </div>
  </div>
</template>

<script>
import InputFile from "@/front/components/partials/InputFile";
import Minus from "@/components/icons/Minus";
import Plus from "@/components/icons/Plus";
import Trash from "@/components/icons/Trash";

export default {
  name: "InputFiles",
  components: {Trash, Plus, Minus, InputFile},
  props: {
    b2Files: {
      type: Array,
      default: []
    },
    scaniiToken: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      nbFiles: [],
      files: {},
    }
  },
  watch: {
    b2Files() {
      this.nbFiles = []
      this.initComponent()
    },
  },
  methods: {
    addFile() {
      this.nbFiles.push(Date.now())
    },
    deleteFile(n) {
      this.nbFiles = this.nbFiles.filter(time => time !== n)
      this.$emit('files-update', this.files)
    },
    deleteServerFile(n, index) {
      this.$emit('delete-server-file', index)
    },
    updateFilesObject(args) {
      this.files[args.id] = args.file
      this.$emit('files-update', this.files)
    },
    initComponent() {
      if (null !== this.b2Files && this.b2Files.length > 0) {
        this.b2Files.forEach((file, i) => {
          this.nbFiles.push(Date.now() + i)
        })
      } else {
        // Create 1 empty file to begin with
        this.nbFiles = [Date.now()]
      }
    },
  },
  beforeMount() {
    this.initComponent()
  },
}
</script>

<style scoped lang="scss">
.inputfiles {

  .inputfiles__file {
    display: grid;
    grid-template-columns: auto 50px;
    grid-column-gap: 2rem;
    align-items: center;

    .deleting {
      opacity: .3;
    }
  }

  .inputfiles__addfile {
    display: flex;
    justify-content: center;
  }

  button {
    padding: 0;
    background-color: transparent;
    color: var(--dark-blue);

    &:hover {
      color: var(--green);
    }
  }
}
</style>
